<div class="column content-container">
	<div class="content-container-header">
		<h3>
			<b>{{ headerText }}</b>
		</h3>
		<p>{{ descriptionText }}</p>
	</div>

	<mat-divider class="margin-bottom-16 margin-left-24 margin-right-24"></mat-divider>

	<div class="content-container-body column spacing-8">
		@if (isOracle) {
			<div class="row">
				<mat-form-field subscriptSizing="dynamic" class="column-double" appearance="outline">
					<mat-label i18n="@@userSearchBar-email">Email</mat-label>
					<input
						matInput
						id="user-search-bar"
						#filterInput
						[matAutocomplete]="auto"
						(keyup)="emailSearchEvents.next(filterInput.value)"
						data-automation-id="user-search-email-input"
					/>
					<mat-icon matPrefix>search</mat-icon>
					<mat-autocomplete #auto="matAutocomplete" [displayWith]="displayUserEmail">
						@for (item of userSearchResults | async; track item.id ?? item) {
							<mat-option
								[value]="item"
								(click)="onUserSelected(item)"
								[attr.data-automation-id]="'user-search-option-' + displayUserSearchItem(item)"
							>
								{{ displayUserSearchItem(item) }}
							</mat-option>
						}
					</mat-autocomplete>
				</mat-form-field>
				<div class="column"></div>
			</div>
			<mat-divider></mat-divider>
		}

		<div class="row spacing-24">
			<mat-form-field subscriptSizing="dynamic" appearance="outline" class="column">
				<mat-label i18n="@@userSearchBar-emailAddress">Email Address</mat-label>
				<input
					matInput
					[(ngModel)]="this.user.email"
					(ngModelChange)="onUserInputChange()"
					(blur)="onEmailBlur()"
					[formControl]="email"
					autocomplete="email"
					data-automation-id="user-search-email-input"
				/>
			</mat-form-field>
			<app-contact-phone-type-form
				class="column"
				[isDisabled]="textEntryDisabled"
				[existingPhoneNumber]="user.phoneNumber"
				(userPhoneNumber)="updateUserPhone($event)"
			>
			</app-contact-phone-type-form>
			<div class="column"></div>
		</div>

		<div class="row spacing-24">
			<mat-form-field subscriptSizing="dynamic" appearance="outline" class="column">
				<mat-label i18n="@@userSearchBar-firstName">First Name</mat-label>
				<input
					matInput
					[disabled]="this.textEntryDisabled"
					[(ngModel)]="this.user.firstName"
					(ngModelChange)="onUserInputChange()"
					[formControl]="firstName"
					autocomplete="given-name"
					data-automation-id="user-search-first-name-input"
				/>
			</mat-form-field>
			<mat-form-field subscriptSizing="dynamic" appearance="outline" class="column">
				<mat-label i18n="@@userSearchBar-lastName">Last Name</mat-label>
				<input
					matInput
					[disabled]="this.textEntryDisabled"
					[(ngModel)]="this.user.lastName"
					(ngModelChange)="onUserInputChange()"
					[formControl]="lastName"
					autocomplete="family-name"
					data-automation-id="user-search-last-name-input"
				/>
			</mat-form-field>
			<div class="column"></div>
		</div>
	</div>
</div>
